<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'orderAddress'+(order?order.id:'')">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="showForm = false;address=null">
      <h3 class="text-center"><i v-if="showForm" class="el-icon-arrow-left back" @click="showForm = false;address=null"></i>收货地址</h3>
      <el-row class="select-address" v-if="!showForm">
        <el-col :span="12" class="tip">
          选择收货地址
        </el-col>
        <el-col :span="12" class="text-right">
          <span class="pointer" @click="showForm = true"><i class="add"></i> <span class="add-tip">添加地址</span></span>
        </el-col>
      </el-row>
      <AddressList :address-id="addressId" :support_transport_service="support_transport_service" v-on:editAddress="editAddress" v-on:changeAddress="changeAddress" v-if="!showForm"></AddressList>
      <el-row v-if="showForm">
        <el-col :span="24" class="tip" v-if="!address">
          添加一个新收货地址
        </el-col>
        <el-col :span="24" class="tip" v-if="address">
          编辑收货地址
        </el-col>
      </el-row>
      <AddressForm :addressInfo="address" :support_transport_service="support_transport_service" v-if="showForm" class="dialog-form" btnType="primary" v-on:success="submit"></AddressForm>
    </el-dialog>
  </div>
</template>

<script>
import AddressForm from './Form'
import AddressList from './AddressList'

export default {
  name: 'AddAddress',
  props: ['addressId', 'support_transport_service', 'order'],
  components: {
    AddressForm: AddressForm,
    AddressList: AddressList
  },
  computed: {
    taskInfo () {
      return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      showForm: false,
      address: null
    }
  },
  methods: {
    show () {
      this.dialogFormVisible = true
    },
    async submit (data) {
      this.dialogFormVisible = false
      this.address = null
      this.showForm = false
      this.$emit('success', this.taskInfo)
    },
    changeAddress (addressInfo) {
      if (!this.addressId) {
        this.taskInfo.address_id = addressInfo.address_id
        this.taskInfo.address_info = addressInfo.address_info
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
      this.dialogFormVisible = false
      this.address = null
      this.$emit('success', addressInfo)
      let data = {
        status: null,
        operationType: '更换成功'
      }
      this.$emit('complete', data)
    },
    editAddress (address) {
      this.showForm = true
      this.address = address
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-top: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    // margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
  }
  .add {
    font-size: 15px !important;
    letter-spacing: 0.1px !important;
    font-family: 'Function Pro Demi' !important;
    color: #333 !important;
    line-height: 33px !important;
  }
  .add::before {
    box-sizing: border-box;
    content: "+" !important;
    display: inline-block !important;
    border: 1px solid #999 !important;
    color: #888 !important;
    border-radius: 50% !important;
    // margin-right: 5px !important;
    height: 16px !important;
    width: 16px !important;
    vertical-align: baseline !important;
    line-height: 11px !important;
    text-align: center !important;
    margin-top: -4px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/AddressDialog.vue